import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { StepperModule } from 'primeng/stepper';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { CardModule } from 'primeng/card';
import { BadgeModule } from 'primeng/badge';
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { MessagesModule } from 'primeng/messages';
import { TabViewModule } from 'primeng/tabview';
import { FieldsetModule } from 'primeng/fieldset';
import { CheckboxModule } from 'primeng/checkbox';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { AuthModule } from 'src/app/auth/auth.module';
import { DistruzioneMassivaComponent } from './distruzione/distruzione-massiva.component';
import { IntestazioneDistruzioneComponent } from './components/intestazione-distruzione.component';
import { IntestazioneRicercaComponent } from './components/ricerca-documenti/components/intestazione-ricerca.component';
import { RiepilogoDistruzioneComponent } from './components/riepilogo-distruzione.component';
import { VerbaleDistruzioneComponent, VerbaleDistruzioneItemComponent } from './components/verbale-distruzione.component';
import { RicercaDocumentiComponent } from './components/ricerca-documenti/ricerca-documenti.component';
import { DocumentiListSelectedComponent } from './components/ricerca-documenti/components/documenti-list-selected.component';
import { RicercaOperazioniMassiveComponent } from './ricerca/ricerca.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OperazioniMassiveListComponent } from './ricerca/components/operazioni-list.component';
import { VerbaleDistruzioneDialogComponent } from './components/verbale-distruzione-dialog.component';
import { StepperStepHeaderComponent } from './components/stepper-step-header.component';
import { VersamentiMassivaComponent } from './versamenti/versamenti-massiva.component';
import { DeclassificaMassivaComponent } from './declassifica/declassifica-massiva.component';
import { InstestazioneDeclassificaComponent } from './components/instestazione-declassifica.component';
import { RiepilogoDeclassificaComponent } from './components/riepilogo-declassifica.component';
import { RiepilogoVersamentiComponent } from './components/riepilogo-versamenti.component';
import { IntestazioneVersamentiComponent } from './components/intestazione-versamenti.component';
import { RiepilogoDeclassificaDialogComponent } from "./components/riepilogo-declassifica-dialog.component";
import { RiepilogoVersamentoDialogComponent } from "./components/riepilogo-versamento-dialog.component";
import { ItemSelectedSummaryComponent } from './components/item-selected-summary.component';




@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    InputTextModule,
    DividerModule,
    DropdownModule,
    StepperModule,
    ButtonModule,
    TableModule,
    AccordionModule,
    InputNumberModule,
    DialogModule,
    CardModule,
    TooltipModule,
    BadgeModule,
    MultiSelectModule,
    MessagesModule,
    TabViewModule,
    FieldsetModule,
    CheckboxModule,
    SplitButtonModule,
    SelectButtonModule,
    SharedModule,
    AuthModule
],
  declarations: [
    DistruzioneMassivaComponent,
    IntestazioneDistruzioneComponent,
    IntestazioneRicercaComponent,
    RiepilogoDistruzioneComponent,
    VerbaleDistruzioneComponent,
    DocumentiListSelectedComponent,
    RicercaDocumentiComponent,
    RicercaOperazioniMassiveComponent,
    OperazioniMassiveListComponent,
    VerbaleDistruzioneDialogComponent,
    VerbaleDistruzioneItemComponent,
    StepperStepHeaderComponent,
    VersamentiMassivaComponent,
    DeclassificaMassivaComponent,
    InstestazioneDeclassificaComponent,
    RiepilogoDeclassificaComponent,
    RiepilogoVersamentiComponent,
    IntestazioneVersamentiComponent,
    RiepilogoDeclassificaDialogComponent,
    RiepilogoVersamentoDialogComponent,
    ItemSelectedSummaryComponent
  ]
})
export class OperazioniMassiveModule { }
